import React from 'react';
import {
  BsDownload,
  BsPencilSquare,
  BsSend,
  BsShieldLock,
  BsToggleOff,
  BsToggleOn,
  BsX
} from 'react-icons/bs';
import { StatusBanca } from '../../../model/banca/Banca';
import AnimatedModal from './AnimatedModal';

interface AdminActionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  banca: any;
  processoId?: string;
  onToggleIntegracao: (banca: any) => void;
  onGerenciarVotacao: (banca: any) => void;
  onPublicarSiga: (banca: any) => void;
  onBaixarResumo: () => void;
  onAlterarStatus: (banca: any) => void;
}

const AdminActionsModal: React.FC<AdminActionsModalProps> = ({
  isOpen,
  onClose,
  banca,
  processoId,
  onToggleIntegracao,
  onGerenciarVotacao,
  onPublicarSiga,
  onBaixarResumo,
  onAlterarStatus
}) => {
  const isIntegracaoToggleDisabled =
    banca.status === StatusBanca.FINALIZADA ||
    banca.status === StatusBanca.FECHADA ||
    banca.status === StatusBanca.CANCELADA;
  const isPublicarSigaDisabled = banca.status !== StatusBanca.FINALIZADA;
  const isDownloadDisabled = !processoId;

  const getOptionStyle = (disabled?: boolean): React.CSSProperties => ({
    width: '100%',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    backgroundColor: disabled ? '#f8f9fa' : '#ffffff',
    color: disabled ? '#6c757d' : '#212529',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.7 : 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 12px',
    fontSize: '14px'
  });

  const triggerAction = (action: () => void, disabled?: boolean) => {
    if (disabled) return;
    action();
    onClose();
  };

  return (
    <AnimatedModal isOpen={isOpen} onClose={onClose}>
      <div
        style={{
          width: 'min(95vw, 440px)',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.2)'
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #e9ecef',
            padding: '14px 16px'
          }}
        >
          <h5 style={{ margin: 0, fontSize: '16px' }}>Ações Administrativas</h5>
          <button
            onClick={onClose}
            style={{
              border: 'none',
              background: 'transparent',
              padding: '4px',
              cursor: 'pointer',
              color: '#6c757d'
            }}
            title="Fechar"
          >
            <BsX size={18} />
          </button>
        </div>

        <div style={{ padding: '14px 16px', display: 'grid', gap: '10px' }}>
          <button
            onClick={() => triggerAction(() => onToggleIntegracao(banca), isIntegracaoToggleDisabled)}
            disabled={isIntegracaoToggleDisabled}
            style={getOptionStyle(isIntegracaoToggleDisabled)}
            title={banca.hasIntegracao ? 'Desabilitar integração' : 'Habilitar integração'}
          >
            {banca.hasIntegracao ? <BsToggleOn size={18} /> : <BsToggleOff size={18} />}
            <span>{banca.hasIntegracao ? 'Desabilitar Integração' : 'Habilitar Integração'}</span>
          </button>

          <button
            onClick={() => triggerAction(() => onGerenciarVotacao(banca))}
            style={getOptionStyle(false)}
            title="Admin - Gerenciar votação"
          >
            <BsShieldLock size={16} />
            <span>Gerenciar Votação (Admin)</span>
          </button>

          <button
            onClick={() => triggerAction(() => onPublicarSiga(banca), isPublicarSigaDisabled)}
            disabled={isPublicarSigaDisabled}
            style={getOptionStyle(isPublicarSigaDisabled)}
            title="Publicar integração SIGA"
          >
            <BsSend size={16} />
            <span>Publicar Integração SIGA</span>
          </button>

          <button
            onClick={() => triggerAction(onBaixarResumo, isDownloadDisabled)}
            disabled={isDownloadDisabled}
            style={getOptionStyle(isDownloadDisabled)}
            title="Status no Processo (também pode ser chamado de resultado parcial - só consolidado como final com finalização do processo)"
          >
            <BsDownload size={16} />
            <span>Baixar Status de Candidatos em JSON</span>
          </button>

          <button
            onClick={() => triggerAction(() => onAlterarStatus(banca))}
            style={getOptionStyle(false)}
            title="Alterar status da banca"
          >
            <BsPencilSquare size={16} />
            <span>Alterar Status da Banca</span>
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default AdminActionsModal;
